import { CardExpirationStatusEnum } from 'features/cardManagement/helpers/CardExpirationStatusEnum';
import { CARD_EXPIRATION_DATE_REGEX } from 'shared/utils/string/cardExpirationDate';

export function isCardAlreadyExpired(
  expiryDate: string,
): CardExpirationStatusEnum {
  if (!CARD_EXPIRATION_DATE_REGEX.test(expiryDate)) {
    return CardExpirationStatusEnum.Unknown;
  }

  const [month, year] = expiryDate.split('/').map(Number);
  if (!month || !year) {
    return CardExpirationStatusEnum.Unknown;
  }

  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear();

  // Correctly convert the two-digit year to a four-digit year
  // example: '23' becomes '2023'
  // ensure base number is less than 100, this ensures we are working with a two-digit year
  const fullYear = year < 100 ? 2000 + year : year;

  if (
    fullYear < currentYear ||
    (fullYear === currentYear && month < currentMonth)
  ) {
    return CardExpirationStatusEnum.Expired;
  } else if (fullYear === currentYear && month === currentMonth) {
    return CardExpirationStatusEnum.ExpiringSoon;
  }

  return CardExpirationStatusEnum.Unknown;
}
